module.exports = __webpack_public_path__ + "static/img/wxscr1.3ea852f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxscr1.png
// module id = 1BwO
// module chunks = 0